import React, { useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

import { FormattedMessage, intlShape } from '../../../util/reactIntl';
import * as validators from '../../../util/validators';
import getCountryCodes from '../../../translations/countryCodes';
import { updateShippingDataToProfile } from '../../../util/shippingdetailsHelper';

import {
  FieldLocationAutocompleteInput,
  FieldRadioButton,
  FieldSelect,
  FieldTextInput,
  Heading,
  IconSpinner,
  NamedLink,
  InputPhoneNumber,
} from '../../../components';
import Select, { components } from 'react-select';

import css from './ShippingDetails.module.css';
import axios from 'axios';
import { apiBaseUrl } from '../../../util/api';
import { isEmpty, isEqual } from 'lodash';
import { getOrderParams, loadInitialDataForStripePayments } from '../CheckoutPageWithPayment';
import { useConfiguration } from '../../../context/configurationContext';
import { getProcess } from '../../../transactions/transaction';
import { hasTransactionPassedPendingPayment } from '../CheckoutPageTransactionHelpers';
import { connect } from 'react-redux';
import { findRouteByRouteName } from '../../../util/routes';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { storeData } from '../CheckoutPageSessionHelpers';
import { ensureLoggedInUser } from '../../../util/data';
import { loggedInUserType } from '../../../ducks/user.duck';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { Field } from 'react-final-form';

const STORAGE_KEY = 'CheckoutPage';
const identity = v => v;

const debounce = func => {
  let timeoutId = null;
  return value => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(func, 250, value);
  };
};

/**
 * A component that displays the shipping details form on the checkout page.
 *
 * @component
 * @param {Object} props
 * @param {string} props.rootClassName - The root class name for the shipping details
 * @param {string} props.className - The class name for the shipping details
 * @param {string} props.locale - The locale
 * @param {intlShape} props.intl - The intl object
 * @param {boolean} props.disabled - Whether the form is disabled
 * @param {Object} props.formApi - The form API from React Final Form
 * @param {string} props.fieldId - The field ID
 */

const LockerComponent = props => {
  const { selectedOption, onChange, lockers, loading, lockerRawData } = props;

  const DropdownIndicator = props => (
    <components.DropdownIndicator {...props} className={css.arrowIndicator}>
      <div className={css.arrowIndicatorContainer}></div>
    </components.DropdownIndicator>
  );
  const customComponents = {
    DropdownIndicator,
    IndicatorSeparator: () => null,
  };

  const customStyles = {
    valueContainer: base => ({
      ...base,
      padding: '2px 16px',
    }),
    singleValue: base => ({
      ...base,
      // color: '#212529',
      fontSize: '1rem',
    }),
    control: (base, state) => ({
      ...base,
      backgroundColor: '#fff',
      transition: 'all ease-in-out 100ms',
      borderColor: state.isFocused ? '#80bdff' : base.borderColor,
      boxShadow: state.isFocused ? '0 0 0 0.2rem rgb(0 123 255 / 25%)' : 'none',
      '&:hover': {
        border: '1px solid #b8bfd1',
        transition: 'all ease-in-out 100ms',
      },
    }),
  };

  // Placeholder changes based on loading state
  const placeholder = loading ? (
    <FormattedMessage id="EditListingDeliveryForm.lockerLoading" />
  ) : (
    <FormattedMessage id="EditListingDeliveryForm.lockerPlaceholder" />
  );

  const selectedLockerData = lockerRawData.find(locker => locker.code === selectedOption?.value);
  return (
    <div className={css.lockerLabelContainer}>
      <label htmlFor="locker-select" className={css.lockeLabel}>
        <FormattedMessage id="EditListingDeliveryForm.lockerLabel" />
      </label>

      <Select
        inputId="locker-select"
        value={selectedOption}
        onChange={onChange}
        options={lockers}
        isSearchable={true}
        isClearable={true}
        classNamePrefix={'custom-select'}
        styles={customStyles}
        placeholder={placeholder}
        components={customComponents}
        className={css.lockerSelect}
      />
      {!isEmpty(selectedLockerData) && (
        <div className={css.lockerInfo}>
          <h3 className={css.lockerTitle}>{selectedLockerData.name}</h3>
          <p className={css.address}>{selectedLockerData.address}</p>

          {/* <div className={css.coordinates}>
            <span>
              📍 <FormattedMessage id="EditListingDeliveryForm.latitude" />:{' '}
              {selectedLockerData.latitude}
            </span>
            <span>
              📍 <FormattedMessage id="EditListingDeliveryForm.longitude" />:{' '}
              {selectedLockerData.longitude}
            </span>
          </div> */}

          <div className={css.openingHours}>
            <FormattedMessage tagName="h4" id="EditListingDeliveryForm.openingHoursTitle" />

            <div className={css.openingHoursTable}>
              <div className={css.row + ' ' + css.header}>
                <div className={css.cell}>
                  <FormattedMessage id="EditListingDeliveryForm.day" />
                </div>
                <div className={css.cell}>
                  <FormattedMessage id="EditListingDeliveryForm.open" />
                </div>
                <div className={css.cell}>
                  <FormattedMessage id="EditListingDeliveryForm.close" />
                </div>
              </div>

              {selectedLockerData?.openinghours?.map((entry, index) => (
                <div key={index} className={css.row}>
                  <div className={css.cell}>{entry.day}</div>
                  <div className={css.cell}>{entry.open_time}</div>
                  <div className={css.cell}>{entry.close_time}</div>
                </div>
              ))}
            </div>
          </div>

          {/* <div className={css.boxTypes}>
            <h4>
              <FormattedMessage id="EditListingDeliveryForm.availableBoxSizes" />
            </h4>
            <div className={css.boxList}>
              {selectedLockerData?.lstTypesBoxes?.map((box, i) => (
                <div key={i} className={css.boxCard}>
                  <div className={css.boxName}>{box.name}</div>
                  <div className={css.boxDetails}>
                    <div className={css.dimension}>
                      📦 {box.width}cm × {box.height}cm × {box.length}cm
                    </div>
                    <div className={css.weight}>
                      ⚖️ {box.weight}kg <FormattedMessage id="EditListingDeliveryForm.max" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div> */}
        </div>
      )}
    </div>
  );
};

const UserFieldPhoneNumber = props => {
  const { className, intl } = props;

  // const validatePhoneNumber = (requiredMsg, invalidMsg) => value => {
  //   if (!value || value.trim() === '') {
  //     return requiredMsg;
  //   }

  //   const isValid = isValidPhoneNumber(`+27${formatPrefilledPhone(value)}`); // expects E.164 format like "+27123456789"
  //   if (!isValid) {
  //     return invalidMsg;
  //   }
  //   return undefined;
  // };

  return (
    <div className={className}>
      <div
        className={css.customPhoneInputLabel}
        onClick={() => {
          document.getElementById('phone-input-recipientPhoneNumber')?.focus();
        }}
      >
        <FormattedMessage id="ShippingDetails.recipientPhoneNumberLabel" />
        <span className={css.astrix}>*</span>
      </div>

      {/* ✅ Use your reusable component */}
      <InputPhoneNumber
        name="recipientPhoneNumber"
        labelId={null} // prevent duplicate label
        required={true}
        placeholder="0712345678"
      />
    </div>
  );
};

const GuestUserEmail = props => {
  const { formApi, loggedInUser, fieldId, intl, values, errors } = props;
  const showEmailField = loggedInUser.type === loggedInUserType.guest;
  const { fetchInProgress, tempEmail, unavailableEmailErr } = values;
  const tempEmailErr = errors.tempEmail;
  const checkEmailAvailability = async value => {
    try {
      if (!value) {
        return;
      }
      batchUpdate({ unavailableEmailErr: null, fetchInProgress: true, recipientEmail: undefined });
      const baseUrl = process.env.REACT_APP_MARKETPLACE_ROOT_URL;
      const url = `${apiBaseUrl(baseUrl)}/api/guest-email/available`;
      const resp = await axios.post(url, { email: value });
      const { available } = resp.data;
      if (!available) {
        const login = (
          <NamedLink name="LoginPage">
            <FormattedMessage id="AuthenticationPage.loginLinkText" />
          </NamedLink>
        );
        batchUpdate({
          unavailableEmailErr: intl.formatMessage(
            { id: 'Checkout.emailUnavailableWeb' },
            { email: value, login }
          ),
          fetchInProgress: false,
        });
      } else {
        batchUpdate({
          recipientEmail: value,
          fetchInProgress: false,
        });
      }
    } catch (e) {
      batchUpdate({
        unavailableEmailErr: intl.formatMessage({ id: 'Checkout.emailUnavailable' }),
        fetchInProgress: false,
      });
    }
  };
  const emailRequired = validators.required(
    intl.formatMessage({
      id: 'SignupForm.emailRequired',
    })
  );
  const emailValid = validators.emailFormatValid(
    intl.formatMessage({
      id: 'SignupForm.emailInvalid',
    })
  );
  const handleUnMount = () => {
    formApi.batch(() => {
      formApi.change('recipientEmail', undefined);
      formApi.change('tempEmail', undefined);
    });
  };

  const batchUpdate = obj => {
    formApi.batch(() => {
      for (let key in obj) {
        formApi.change(key, obj[key]);
      }
    });
  };

  const debounceCb = useCallback(debounce(checkEmailAvailability), []);

  useEffect(() => {
    if (!tempEmailErr && showEmailField) {
      debounceCb(tempEmail);
    }
  }, [tempEmailErr, tempEmail, showEmailField]);

  return showEmailField ? (
    <div className={css.emailPlace}>
      <FieldTextInput
        id={`${fieldId}.recipientEmail`}
        name="tempEmail"
        className={css.fieldFullWidth}
        type="text"
        autoComplete="shipping email"
        label={intl.formatMessage({ id: 'ShippingDetails.recipientEmailLabel' })}
        placeholder={intl.formatMessage({
          id: 'ShippingDetails.recipientEmailPlaceholder',
        })}
        onUnmount={handleUnMount}
        validate={validators.syncComposeValidators(emailRequired, emailValid)}
      />
      <div className={css.astrixPositionedEmail}>*</div>
      {fetchInProgress ? (
        <p className={css.emailCheckContainer}>
          <IconSpinner />
          <FormattedMessage id="Checkout.emailChecking" />
        </p>
      ) : unavailableEmailErr && !tempEmailErr ? (
        <p className={css.emailCheckErrContainer}>{unavailableEmailErr}</p>
      ) : null}
    </div>
  ) : null;
};

const ShippingDetails = props => {
  const {
    rootClassName,
    className,
    locale,
    intl,
    disabled,
    formApi,
    fieldId,
    values,
    fetchSpeculatedTransaction,
    pageData,
    setPageData,
    currentUser,
    guestUser,
    loggedInUserType,
    callSetInitialValues,
    errors,
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const authenticatedUser = ensureLoggedInUser(currentUser, guestUser);
  const { listing } = pageData;
  const { attributes } = listing || {};
  const { publicData } = attributes || {};
  const {
    locker,
    location,
    shippingType: providerShippingType,
    productDimensions,
    addressType: providerAddressType,
  } = publicData || {};
  const shippingToCall =
    providerShippingType === 'locker' && values.shippingType === 'locker'
      ? 'L2L'
      : providerShippingType === 'door' && values.shippingType === 'locker'
      ? 'D2L'
      : providerShippingType === 'locker' && values.shippingType === 'door'
      ? 'L2D'
      : 'D2D';
  const config = useConfiguration();
  const lockerData = config.lockerData;
  const [selectedOption, setSelectedOption] = useState();
  const pickupEnabled = !!authenticatedUser.attributes.profile.publicData.profileUrl;
  const addressRequiredMessage = intl.formatMessage({
    id: 'EditListingDeliveryForm.addressRequired',
  });
  const addressNotRecognizedMessage = intl.formatMessage({
    id: 'EditListingDeliveryForm.addressNotRecognized',
  });
  const shippingDisabled = !(
    values.recipientName &&
    values.recipientEmail &&
    values.recipientPhoneNumber
  );

  // useEffect(() => {
  //   const shippingType = pageData?.orderData?.shippingType;
  //   formApi.change('shippingType', shippingType);
  //   if (shippingType === 'locker') {
  //     const lockerCode = pageData?.orderData?.lockerCode;
  //     const selectedLocker = lockers.find(({ value }) => value === lockerCode);
  //     setSelectedOption(selectedLocker);
  //   }
  // }, [pageData, lockers]);

  const optionalText = intl.formatMessage({
    id: 'ShippingDetails.optionalText',
  });

  // Use the language set in config.localization.locale to get the correct translations of the country names
  const countryCodes = getCountryCodes(locale);

  const lockerLabel = intl.formatMessage({ id: 'EditListingDeliveryForm.lockerLabel' });
  const pickupLabel = intl.formatMessage({ id: 'EditListingDeliveryForm.pickupLabel' });

  // const fetchLineItem = pageData => {
  //   const orderParams = getOrderParams(pageData, {}, {}, config);

  //   const tx = pageData ? pageData.transaction : null;
  //   const pageDataListing = pageData.listing;
  //   const processName =
  //     tx?.attributes?.processName ||
  //     pageDataListing?.attributes?.publicData?.transactionProcessAlias?.split('/')[0];
  //   const process = processName ? getProcess(processName) : null;

  //   // If transaction has passed payment-pending state, speculated tx is not needed.
  //   const shouldFetchSpeculatedTransaction =
  //     !!pageData?.listing?.id &&
  //     !!pageData.orderData &&
  //     !!process &&
  //     !hasTransactionPassedPendingPayment(tx, process);

  //   if (shouldFetchSpeculatedTransaction) {
  //     const processAlias = pageData.listing.attributes.publicData?.transactionProcessAlias;
  //     const transactionId = tx ? tx.id : null;
  //     const isInquiryInPaymentProcess =
  //       tx?.attributes?.lastTransition === process.transitions.INQUIRE;

  //     const requestTransition = isInquiryInPaymentProcess
  //       ? process.transitions.REQUEST_PAYMENT_AFTER_INQUIRY
  //       : process.transitions.REQUEST_PAYMENT;
  //     const isPrivileged = process.isPrivileged(requestTransition);

  //     fetchSpeculatedTransaction(
  //       orderParams,
  //       processAlias,
  //       transactionId,
  //       requestTransition,
  //       isPrivileged
  //     );
  //   }
  // };

  // const fetchShippingRates = async destinationDetails => {
  //   const { width, height, length, weight } = productDimensions || {};
  //   if (!height || !width || !length || !weight) {
  //     return;
  //   }

  //   try {
  //     // setRateLoading(true);

  //     const parcelData = {
  //       width: parseFloat(width),
  //       height: parseFloat(height),
  //       length: parseFloat(length),
  //       weight: parseFloat(weight),
  //     };

  //     const requestData = { parcels: [parcelData] };

  //     // Add type-specific data
  //     switch (shippingToCall) {
  //       case 'D2D':
  //         requestData.collection_address = {
  //           entered_address: location?.address,
  //           lat: location?.origin?.lat,
  //           lng: location?.origin?.lng,
  //           type: providerAddressType,
  //         };
  //         requestData.delivery_address = destinationDetails?.address;
  //         break;
  //       case 'D2L':
  //         requestData.collection_address = {
  //           entered_address: location?.address,
  //           lat: location?.origin?.lat,
  //           lng: location?.origin?.lng,
  //           type: providerAddressType,
  //         };
  //         requestData.delivery_terminal_id = destinationDetails?.lockerCode;
  //         break;
  //       case 'L2D':
  //         requestData.collection_terminal_id = locker;
  //         requestData.delivery_address = destinationDetails?.address;
  //         break;
  //       case 'L2L':
  //         requestData.collection_terminal_id = locker;
  //         requestData.delivery_terminal_id = destinationDetails?.lockerCode;
  //         break;
  //       default:
  //         console.warn('Unknown shipping type:', shippingToCall);
  //         return;
  //     }

  //     const response = await axios.post(`${apiBaseUrl()}/api/shipping/fetchShippingRates`, {
  //       type: shippingToCall,
  //       data: requestData,
  //     });
  //     return response.data || [];
  //   } catch (error) {
  //     console.error('Error fetching shipping rates:', error);
  //   }
  // };

  // useEffect(() => {
  //   const selectedPlace = values.location?.selectedPlace;
  //   if (
  //     selectedPlace &&
  //     selectedPlace.origin &&
  //     (!isEqual(values.location, pageData.orderData.location) ||
  //       !isEqual(values.addressType, pageData.orderData.addressType))
  //   ) {
  //     const { lat, lng } = selectedPlace.origin;
  //     const payload = {
  //       address: { entered_address: values.location?.search, lat, lng, type: values?.addressType },
  //     };
  //     fetchShippingRates(payload).then((rate = []) => {
  //       const optimalRate = [...rate].sort((a, b) => parseFloat(a.rate) - parseFloat(b.rate))[0];
  //       const updatedPageData = {
  //         ...pageData,
  //         orderData: {
  //           ...pageData.orderData,
  //           shippingCharge: optimalRate?.rate,
  //           serviceTaken: optimalRate?.service_level,
  //           shippingType: values?.shippingType,
  //           lockerCode: null,
  //           location: values.location,
  //           addressType: values?.addressType,
  //           building: values?.building || null,
  //         },
  //       };

  //       setPageData({ ...updatedPageData });

  //       const { setInitialValues } = findRouteByRouteName('CheckoutPage', routeConfiguration);

  //       callSetInitialValues(setInitialValues, updatedPageData, false);

  //       storeData(updatedPageData.orderData, listing, null, STORAGE_KEY);

  //       fetchLineItem(updatedPageData);
  //     });
  //   }
  // }, [values.location?.selectedPlace, values.addressType]);

  const handleChange = async val => {
    setSelectedOption(val);
    formApi.change('selectedLocker', val);
    formApi.change('locker', val?.value);

    // const rate =
    //   (await fetchShippingRates({
    //     lockerCode: val?.value,
    //   })) || [];
    // const optimalRate = [...rate].sort((a, b) => parseFloat(a.rate) - parseFloat(b.rate))[0];
    // const updatedPageData = {
    //   ...pageData,
    //   orderData: {
    //     ...pageData.orderData,
    //     shippingCharge: optimalRate?.rate,
    //     lockerCode: val?.value,
    //     selectedLocker: val,
    //     shippingType: values?.shippingType,
    //     serviceTaken: optimalRate?.service_level,
    //   },
    // };

    // setPageData({ ...updatedPageData });

    // const { setInitialValues } = findRouteByRouteName('CheckoutPage', routeConfiguration);

    // callSetInitialValues(setInitialValues, updatedPageData, false);

    // storeData(updatedPageData.orderData, listing, null, STORAGE_KEY);

    // fetchLineItem(updatedPageData);
  };
  return (
    <div className={classes}>
      <Heading as="h3" rootClassName={css.heading}>
        <FormattedMessage id="ShippingDetails.title" />
        <span className={css.astrixTitle}>*</span>
      </Heading>

      <div className={classNames(css.radioContainer, css.radioGroup)}>
        <FieldRadioButton
          id={`${fieldId}-pickup`}
          name="shippingType"
          label={pickupLabel}
          value="door"
          className={css.custRadio}
        />
        <FieldRadioButton
          id={`${fieldId}-locker`}
          name="shippingType"
          label={lockerLabel}
          value="locker"
          className={css.custRadio}
          // showAsRequired={pristine}
        />
      </div>

      <div className={css.fullNameField}>
        <FieldTextInput
          id={`${fieldId}.recipientName`}
          name="recipientName"
          disabled={disabled}
          className={css.fieldFullWidth}
          type="text"
          autoComplete="shipping name"
          label={intl.formatMessage({ id: 'ShippingDetails.recipientNameLabel' })}
          placeholder={intl.formatMessage({
            id: 'ShippingDetails.recipientNamePlaceholder',
          })}
          validate={validators.required(
            intl.formatMessage({ id: 'ShippingDetails.recipientNameRequired' })
          )}
          onUnmount={() => formApi.change('recipientName', undefined)}
        />
        <span className={css.astrixPositioned}>*</span>
      </div>

      <GuestUserEmail
        formApi={formApi}
        loggedInUser={authenticatedUser}
        fieldId={fieldId}
        intl={intl}
        values={values}
        errors={errors}
      />
      {/* <FieldTextInput
        id={`${fieldId}.recipientPhoneNumber`}
        name="recipientPhoneNumber"
        disabled={disabled}
        className={css.fieldFullWidth}
        type="text"
        autoComplete="shipping phoneNumber"
        label={intl.formatMessage(
          { id: 'ShippingDetails.recipientPhoneNumberLabel' },
          { optionalText: optionalText }
        )}
        placeholder={intl.formatMessage({
          id: 'ShippingDetails.recipientPhoneNumberPlaceholder',
        })}
        validate={validators.required(
          intl.formatMessage({ id: 'ShippingDetails.recipientPhoneNumberRequired' })
        )}
        onUnmount={() => formApi.change('recipientPhoneNumber', undefined)}
      /> */}
      <UserFieldPhoneNumber intl={intl} className={css.row} />

      {values.shippingType === 'door' && !shippingDisabled && (
        <>
          <div className={css.inputLocation}>
            <FieldLocationAutocompleteInput
              rootClassName={css.input}
              inputClassName={css.locationAutocompleteInput}
              iconClassName={css.locationAutocompleteInputIcon}
              predictionsClassName={css.predictionsRoot}
              validClassName={css.validLocation}
              // autoFocus={autoFocus}
              name="location"
              label={intl.formatMessage({ id: 'ShippingDetails.recipientAddress' })}
              placeholder={intl.formatMessage({
                id: 'EditListingDeliveryForm.addressPlaceholder',
              })}
              useDefaultPredictions={false}
              format={identity}
              valueFromForm={values.location}
              validate={
                pickupEnabled
                  ? validators.composeValidators(
                      validators.autocompleteSearchRequired(addressRequiredMessage),
                      validators.autocompletePlaceSelected(addressNotRecognizedMessage)
                    )
                  : () => {}
              }
              hideErrorMessage={!pickupEnabled}
              // Whatever parameters are being used to calculate
              // the validation function need to be combined in such
              // a way that, when they change, this key prop
              // changes, thus reregistering this field (and its
              // validation function) with Final Form.
              // See example: https://codesandbox.io/s/changing-field-level-validators-zc8ei
              key={pickupEnabled ? 'locationValidation' : 'noLocationValidation'}
            />
            <FieldTextInput
              className={css.input}
              type="text"
              name="building"
              id={'building'}
              label={intl.formatMessage(
                { id: 'ShippingDetails.recipientBuilding' },
                { optionalText }
              )}
              placeholder={intl.formatMessage({
                id: 'EditListingDeliveryForm.buildingPlaceholder',
              })}
            />
          </div>
          <div className={css.formRow}>
            <label className={css.addressTypeLabel}>
              {intl.formatMessage({ id: 'ShippingDetails.addressTypeLabel' })}
            </label>
            <div className={classNames(css.radioGroup, css.endRadioGroup)}>
              <FieldRadioButton
                id={`${fieldId}.addressType.residential`}
                name="addressType"
                label={intl.formatMessage({ id: 'ShippingDetails.residentialLabel' })}
                value="residential"
                className={css.custRadio}
              />
              <FieldRadioButton
                id={`${fieldId}.addressType.business`}
                name="addressType"
                label={intl.formatMessage({ id: 'ShippingDetails.businessLabel' })}
                value="business"
                className={css.custRadio}
              />
            </div>
          </div>
          {/* <div className={css.formRow}>
            <FieldTextInput
              id={`${fieldId}.recipientAddressLine1`}
              name="recipientAddressLine1"
              disabled={disabled}
              className={css.field}
              type="text"
              autoComplete="shipping address-line1"
              label={intl.formatMessage({ id: 'ShippingDetails.addressLine1Label' })}
              placeholder={intl.formatMessage({
                id: 'ShippingDetails.addressLine1Placeholder',
              })}
              validate={validators.required(
                intl.formatMessage({ id: 'ShippingDetails.addressLine1Required' })
              )}
              onUnmount={() => formApi.change('recipientAddressLine1', undefined)}
            />

            <FieldTextInput
              id={`${fieldId}.recipientAddressLine2`}
              name="recipientAddressLine2"
              disabled={disabled}
              className={css.field}
              type="text"
              autoComplete="shipping address-line2"
              label={intl.formatMessage(
                { id: 'ShippingDetails.addressLine2Label' },
                { optionalText: optionalText }
              )}
              placeholder={intl.formatMessage({
                id: 'ShippingDetails.addressLine2Placeholder',
              })}
              onUnmount={() => formApi.change('recipientAddressLine2', undefined)}
            />
          </div>
          <div className={css.formRow}>
            <FieldTextInput
              id={`${fieldId}.recipientPostalCode`}
              name="recipientPostal"
              disabled={disabled}
              className={css.field}
              type="text"
              autoComplete="shipping postal-code"
              label={intl.formatMessage({ id: 'ShippingDetails.postalCodeLabel' })}
              placeholder={intl.formatMessage({
                id: 'ShippingDetails.postalCodePlaceholder',
              })}
              validate={validators.required(
                intl.formatMessage({ id: 'ShippingDetails.postalCodeRequired' })
              )}
              onUnmount={() => formApi.change('recipientPostal', undefined)}
            />

            <FieldTextInput
              id={`${fieldId}.recipientCity`}
              name="recipientCity"
              disabled={disabled}
              className={css.field}
              type="text"
              autoComplete="shipping address-level2"
              label={intl.formatMessage({ id: 'ShippingDetails.cityLabel' })}
              placeholder={intl.formatMessage({ id: 'ShippingDetails.cityPlaceholder' })}
              validate={validators.required(
                intl.formatMessage({ id: 'ShippingDetails.cityRequired' })
              )}
              onUnmount={() => formApi.change('recipientCity', undefined)}
            />
          </div>
          <div className={css.formRow}>
            <FieldTextInput
              id={`${fieldId}.recipientState`}
              name="recipientState"
              disabled={disabled}
              className={css.field}
              type="text"
              autoComplete="shipping address-level1"
              label={intl.formatMessage(
                { id: 'ShippingDetails.stateLabel' },
                { optionalText: optionalText }
              )}
              placeholder={intl.formatMessage({ id: 'ShippingDetails.statePlaceholder' })}
              onUnmount={() => formApi.change('recipientState', undefined)}
            />

            <FieldSelect
              id={`${fieldId}.recipientCountry`}
              name="recipientCountry"
              disabled={disabled}
              className={css.field}
              label={intl.formatMessage({ id: 'ShippingDetails.countryLabel' })}
              validate={validators.required(
                intl.formatMessage({ id: 'ShippingDetails.countryRequired' })
              )}
            >
              <option disabled value="">
                {intl.formatMessage({ id: 'ShippingDetails.countryPlaceholder' })}
              </option>
              {countryCodes.map(country => {
                return (
                  <option key={country.code} value={country.code}>
                    {country.name}
                  </option>
                );
              })}
            </FieldSelect> */}
          {/* </div> */}
        </>
      )}

      {values.shippingType === 'locker' && !shippingDisabled && (
        <LockerComponent
          lockers={lockerData.lockers}
          selectedOption={selectedOption}
          onChange={handleChange}
          loading={false}
          lockerRawData={lockerData.rawData}
        />
      )}
      {shippingDisabled ? <div style={{ marginBottom: '40px' }} /> : null}
    </div>
  );
};

const mapStateToProps = state => {
  const { currentUser, guestUser, loggedInUserType } = state.user;
  return { currentUser, guestUser, loggedInUserType };
};
export default connect(mapStateToProps)(ShippingDetails);
